import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useManagedProps } from "./useManagedProps.js";
import { TextInput } from "../components/textInput/TextInput.js";
const ManagedTextInput = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { propsWithRef } = useManagedProps(props, ref);
    return /*#__PURE__*/ jsx(TextInput, {
        ...propsWithRef
    });
});
ManagedTextInput.displayName = 'ManagedTextInput';
export { ManagedTextInput };
